import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '../tracking/consent';
import './CookieBanner.css';

export default function CookieBanner() {
  const [sichtbar, setSichtbar] = useState(false);

  useEffect(() => {
    // Banner nur zeigen wenn noch keine Entscheidung getroffen wurde
    if (!getConsent()) {
      const t = setTimeout(() => setSichtbar(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const akzeptieren = () => {
    setConsent('granted');
    setSichtbar(false);
  };

  const ablehnen = () => {
    setConsent('denied');
    setSichtbar(false);
  };

  if (!sichtbar) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie-Einwilligung">
      <div className="cookie-banner__inner">
        <div className="cookie-banner__text">
          <span className="cookie-banner__icon">🍪</span>
          <span>
            Wir möchten Analyse- und Marketing-Technologien (Google Analytics, PostHog,
            TikTok Pixel) verwenden, um unser Angebot zu verbessern. Technisch notwendige
            Speicherungen sind immer aktiv.{' '}
            <Link to="/datenschutz" className="cookie-banner__link">Mehr erfahren</Link>
          </span>
        </div>
        <div className="cookie-banner__actions">
          <button
            className="cookie-banner__btn cookie-banner__btn--accept"
            onClick={akzeptieren}
            aria-label="Alle Cookies akzeptieren"
          >
            Akzeptieren
          </button>
          <button
            className="cookie-banner__btn cookie-banner__btn--deny"
            onClick={ablehnen}
            aria-label="Nur notwendige Cookies"
          >
            Ablehnen
          </button>
        </div>
      </div>
    </div>
  );
}
